<div class="plano-contas-container">
  <div class="header d-flex justify-content-between align-items-center mb-3">
    <h1>Plano de Contas</h1>
    <button class="btn btn-primary" (click)="novo(modalCadastro)">
      <i class="fa fa-plus"></i> Adicionar conta raiz
    </button>
  </div>

  <div class="card-box mb-3">
    <h5 class="mb-3">Cadastro em árvore</h5>
    <div class="tree-wrap" *ngIf="itensArvore?.length; else semContas">
      <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: itensArvore, nivel: 0 }"></ng-container>
    </div>
    <ng-template #semContas>
      <div class="text-muted">Nenhuma conta cadastrada.</div>
    </ng-template>

    <ng-template #nodeTemplate let-nos let-nivel="nivel">
      <ul class="tree-level" [class.root-level]="nivel === 0">
        <li class="tree-node" *ngFor="let item of nos">
          <div class="node-card">
            <div class="node-left">
              <button
                class="btn-toggle"
                *ngIf="temFilhos(item)"
                type="button"
                (click)="alternarExpandir(item)">
                <i class="fa" [ngClass]="estaExpandido(item) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
              </button>
              <span class="node-code">{{ item.codigo }}</span>
              <span class="node-name">{{ item.nome }}</span>
              <span class="badge badge-light">{{ item.tipo }}</span>
              <span class="badge" [ngClass]="item.natureza === 'ENTRADA' ? 'badge-success' : 'badge-danger'">{{ item.natureza }}</span>
            </div>
            <div class="node-actions">
              <button
                *ngIf="podeAdicionarFilha(item)"
                class="btn btn-outline-success btn-sm"
                type="button"
                (click)="novoFilha(item, modalCadastro)">
                <i class="fa fa-plus mr-1"></i>Filha
              </button>
              <button class="btn btn-outline-primary btn-sm" type="button" (click)="editarArvore(item, modalCadastro)">
                <i class="fa fa-pencil mr-1"></i>Editar
              </button>
              <button class="btn btn-outline-danger btn-sm" type="button" (click)="excluirArvore(item)">
                <i class="fa fa-trash mr-1"></i>Remover
              </button>
            </div>
          </div>

          <ng-container *ngIf="temFilhos(item) && estaExpandido(item)">
            <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: item.filhos, nivel: nivel + 1 }"></ng-container>
          </ng-container>
        </li>
      </ul>
    </ng-template>
  </div>

  <ng-template #modalCadastro let-modal>
    <div class="modal-header">
      <h5 class="modal-title">{{ editandoId > 0 ? 'Editar Conta' : 'Nova Conta' }}</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label">Código *</label>
          <input type="text" class="form-control" [(ngModel)]="codigo" />
        </div>
        <div class="col-md-8">
          <label class="form-label">Nome *</label>
          <input type="text" class="form-control" [(ngModel)]="nome" />
        </div>
        <div class="col-md-4">
          <label class="form-label">Tipo *</label>
          <select class="form-control" [(ngModel)]="tipo">
            <option value="SINTETICA">SINTETICA</option>
            <option value="ANALITICA">ANALITICA</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Natureza *</label>
          <select class="form-control" [(ngModel)]="natureza">
            <option value="ENTRADA">ENTRADA</option>
            <option value="SAIDA">SAIDA</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Conta Pai</label>
          <select class="form-control" [(ngModel)]="contaPaiId">
            <option [ngValue]="null">Nenhuma</option>
            <option *ngFor="let item of contasPaiDisponiveis" [ngValue]="item.id">
              {{ item.codigo }} - {{ item.nome }}
            </option>
          </select>
        </div>
        <div class="col-md-4 d-flex align-items-end">
          <div class="form-check">
            <input id="ativoPlanoConta" class="form-check-input" type="checkbox" [(ngModel)]="ativo" />
            <label for="ativoPlanoConta" class="form-check-label">Ativo</label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
      <button class="btn btn-success" (click)="salvar()">Salvar</button>
    </div>
  </ng-template>
</div>
